import React, { useState, useEffect } from 'react';
import Switch from "react-switch";
import { connect } from 'react-redux';
import { updateMute } from '../../../redux/actions';
import { captureMessage } from '@sentry/react';
import './messenger.scss';

const Mute = ({ isMute, active, muteVal, updateMuteHere }) => {
  const [userInformation, setUserInformation] = useState({})

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && Object.keys(user).length > 0) {
      setUserInformation(user);
    }
  }, []);


  useEffect(() => {
      if (muteVal) {
          $('.react-switch-handle').addClass('switch-enabled');
      } else {
          $('.react-switch-handle').removeClass('switch-enabled');
      }
  }, [muteVal]);

    const changeMute = (newMuteVal) => {
        updateMuteHere(!newMuteVal);

        const formData = new FormData();
        formData.append('blocker_id', localStorage.getItem('loggedin_user'));
        formData.append('blocked_id', active);

        if(!isMute) {
          formData.append('mute_action', 'yes');
          $('.react-switch-handle').addClass('switch-enabled');
        } else {
          formData.append('mute_action', 'no');
          $('.react-switch-handle').removeClass('switch-enabled');
        }

        axios({
          method: 'post',
          url: '/api/followers/block/' + active,
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then((data) => {
            //setShowLoader(false);
          })
          .catch((error) => {
            captureMessage(error)
          });
      };

    return <div className="mute-chat">
          <label className="switch">
              <Switch
                  onChange={() => changeMute(muteVal)}
                  checked={muteVal}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={20}
                  width={35}
                  onColor="#0097fe"
                  disabled={active == 1 || active == 30167}
              />
              <span className="mute-text">Mute</span>
          </label>
      </div>
}

function mapStateToProps(state) {
    return {
      muteVal: state.message.mute_val
    }
  }

function mapDispatchToProps(dispatch) {
    //return bindActionCreators({updateMute}, dispatch)
    return {
        updateMuteHere: (mute_val) => dispatch(updateMute(mute_val))
    }
}

//const mapDispatchToProps = { updateMute };

export default connect(mapStateToProps, mapDispatchToProps)(Mute);
